<template>
    <main class="blackfriday tw-bg-cover tw-bg-center">
        <header class="">
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-py-2">
                <img src="~@/assets/img/logo.svg" alt="Minisom" title="Minisom">
            </div>
        </header>
        <section class="hero tw-grid tw-grid-cols-1 tw-items-center tw-justify-center lg:tw-flex lg:tw-items-start lg:tw-justify-between tw-h-full">
            <div class="info-container">
                <h1 class="tw-opacity-0 tw-pointer-events-none tw-absolute">Black Friday</h1>
                <h2 class="tw-opacity-0 tw-pointer-events-none tw-absolute">1 Aparelho Auditivo GRÁTIS</h2>
                <h3 class="tw-opacity-0 tw-pointer-events-none tw-absolute">Stock limitado</h3>
                <img src="~@/assets/img/bf-hero-mobile.jpg" class="tw-block lg:tw-hidden">
                <img src="~@/assets/img/bf-hero-desktop.jpg" class="tw-hidden lg:tw-block">
            </div>
            <div class="form-container">
                <Form v-if="!$store.state.formSuccess" />
                <FormSuccess v-if="$store.state.formSuccess" />
                <p v-if="!$store.state.formSuccess">Apresse-se. O stock é limitado!</p>
            </div>
        </section>
        <footer>
            <div class="tw-container">
                <div class="legals tw-container tw-pt-5 lg:tw-pt-10">
                    <p>1 Aparelho Auditivo Grátis na aquisição de 2 aparelhos auditivos da gama 5, no período de 02 a 30/11/2023, não acumulável com outras campanhas, descontos ou promoções em vigor e limitada ao stock existente.</p>
                </div>
            </div>
        </footer>
    </main>
</template>
<script>
import Form from '@/components/FormBlackfriday.vue';
import FormSuccess from '@/components/FormSuccessBlackfriday.vue';

export default {
    name: 'Blackfriday',
    components: {
        Form,
        FormSuccess,
    },
    mounted() {
        // Change the preview image for Blackfriday
        document.querySelector('meta[property="og:image"]').setAttribute("content", "https://minisom.aparelho.pt/preview-bf.jpg");
    },
};
</script>
